import { Box, Text } from '@factorialco/deprecated-design-system'
import { A3IncidenceFinanceCostCenterAssignmentFragment } from 'generated/resources/graphql'

import DetailLine from 'modules/payroll_bundle/pages/IncidenceDetailPage/_DetailLine'

const parsePercentage = (percentage: number) => {
  return `${(percentage * 100).toFixed(0)}%`
}

interface Props {
  title: string
  costCenters: A3IncidenceFinanceCostCenterAssignmentFragment[]
}

export const CostCentersHiringDetails = ({ title, costCenters }: Props) => {
  return (
    <Box gap="s8" paddingBottom="s24">
      <Text.Normal size="200" color="grey800" weight="bold">
        {title}
      </Text.Normal>

      <Box gap="s2" component="ul" paddingLeft="s16" style={{ listStyle: 'disc' }}>
        {costCenters
          .filter((assignment) => !!assignment.costCenter)
          .map((assignment) => {
            const costCenter = assignment.costCenter

            if (costCenter == null) return null

            return (
              <DetailLine
                key={costCenter.name}
                component="li"
                title={costCenter.name}
                value={parsePercentage(assignment.percentage)}
                style={{ display: 'list-item' }}
              />
            )
          })}
      </Box>
    </Box>
  )
}
